<div class="cell auto grid-y cell-block-y blockContent">
    <div class="cell shrink grid-x align-middle align-justify">
        <h2 class="cell shrink _primary _sansSerif"
            [innerHTML]="'study.humanResourcesParameters.paragraph.1'|translate" [i18nKey]="[{target: 'innerHTML', key: 'study.humanResourcesParameters.paragraph.1'}]"></h2>
        <a *ngIf="!isSpecimen" class="cell shrink button _iconRight"
           href="/static/tools/new-kiwi/humanResourcesParameters/fr/simulator.xlsx">
            <span [i18nKey]="'study.humanResourcesParameters.download'"></span>
            <i class="fas fa-file-download"></i>
        </a>
        <a *ngIf="isSpecimen" class="cell disabled shrink button _iconRight">
            <span [i18nKey]="'study.humanResourcesParameters.download'"></span>
            <i class="fas fa-file-download"></i>
        </a>
    </div>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p class="cell shrink"[i18nKey]="'study.humanResourcesParameters.paragraph.2'"></p>
    <p class="cell shrink categoryDescription"
       [innerHTML]="'study.humanResourcesParameters.paragraph.3'|translate" [i18nKey]="[{target: 'innerHTML', key: 'study.humanResourcesParameters.paragraph.3'}]"></p>

    <div class="cell shrink grid-x align-center">
        <div class="cell shrink hrItem _restaurant"
             [innerHTML]="labelKeyOrLoremIpsum('study.humanResourcesParameters.item.1') | translate : {limitBetweenType1AndType2: limitBetweenType1AndType2}"></div>
        <div class="cell shrink hrItem _restaurant"
             [innerHTML]="labelKeyOrLoremIpsum('study.humanResourcesParameters.item.2') | translate : {
             limitBetweenType1AndType2: limitBetweenType1AndType2,
             limitBetweenType2AndType3: limitBetweenType2AndType3
             }"></div>
        <div class="cell shrink hrItem _restaurant"
             [innerHTML]="labelKeyOrLoremIpsum('study.humanResourcesParameters.item.3') | translate : {limitBetweenType2AndType3: limitBetweenType2AndType3}"></div>
    </div>

    <kiwi-spacer [size]="8"></kiwi-spacer>

    <p class="cell shrink categoryDescription"
       [innerHTML]="'study.humanResourcesParameters.paragraph.4'|translate" [i18nKey]="[{target: 'innerHTML', key: 'study.humanResourcesParameters.paragraph.4'}]"></p>

    <div class="cell shrink grid-x align-center">
        <div class="cell shrink hrItem _staff"
             [innerHTML]="labelKeyOrLoremIpsum('study.humanResourcesParameters.item.4') | translate"></div>
        <div class="cell shrink hrItem _staff"
             [innerHTML]="labelKeyOrLoremIpsum('study.humanResourcesParameters.item.5') | translate"></div>
        <div class="cell shrink hrItem _staff"
             [innerHTML]="labelKeyOrLoremIpsum('study.humanResourcesParameters.item.6') | translate"></div>
    </div>

    <p class="cell shrink">{{labelKeyOrLoremIpsum('study.humanResourcesParameters.paragraph.5') | translate}}</p>
    <p class="cell shrink">{{labelKeyOrLoremIpsum('study.humanResourcesParameters.paragraph.6') | translate}}</p>
</div>
